var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('bundle-discount-label',{class:_vm.postMountClass,attrs:{"label-color":_vm.labelColor}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }